import { render, staticRenderFns } from "./add-message.vue?vue&type=template&id=47938829&scoped=true&"
import script from "./add-message.vue?vue&type=script&lang=js&"
export * from "./add-message.vue?vue&type=script&lang=js&"
import style0 from "./add-message.vue?vue&type=style&index=0&id=47938829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47938829",
  null
  
)

export default component.exports